module.exports = __webpack_public_path__ + "static/media/work3.4197c198.png";